export default {
  init() {
    // JavaScript to be fired on the home page

      $('.home-quote-slider').slick({
          autoplay: true,
          autoplaySpeed: 20000,
          arrows: true,
          dots: true,
          nextArrow: '<i class="ll-slick-arrow ll-slick-arrow--next fa fa-chevron-right"></i>',
          prevArrow: '<i class="ll-slick-arrow ll-slick-arrow--prev fa fa-chevron-left"></i>',
      })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js